import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';
import { mockData } from '../mock';

const FAQSection = () => {
  return (
    <section id="faq" className="py-20 bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <p className="text-xl lg:text-2xl text-gray-600 mb-4 font-medium">
            様々な疑問にお答えします
          </p>
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-6">
            よくある質問
          </h2>
        </div>

        <div className="bg-white rounded-xl shadow-lg p-8">
          <Accordion type="single" collapsible className="w-full space-y-4">
            {mockData.faq.map((item, index) => (
              <AccordionItem 
                key={index} 
                value={`item-${index}`}
                className="border border-gray-200 rounded-lg px-6"
              >
                <AccordionTrigger className="text-left font-semibold text-gray-900 hover:text-blue-600 py-6">
                  {item.question}
                </AccordionTrigger>
                <AccordionContent className="text-gray-600 leading-relaxed pb-6">
                  {item.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;